// Section types
export type CashSection = 'overview' | 'operations' | 'reporting';

// Menu types for reconciliation section
export type CashMenu =
  | 'pending'
  | 'for-review'
  | 'journal-entries'
  | 'reconciled';

// Tab types for for-review menu
export type CashTab = 'reconcile' | 'match' | 'categorize' | 'no-match';

// Default values
export const DEFAULT_SECTION: CashSection = 'overview';
export const DEFAULT_MENU: CashMenu = 'for-review';
export const DEFAULT_TAB: CashTab = 'reconcile';

// URL constants
export const cashURLs = {
  // Base path
  base: '/cash',
  _base_relative_path: 'cash',

  // Overview section
  overview: '/cash/overview',
  _overview_relative_path: 'overview',

  // Reconciliation section
  reconciliation: '/cash/accounting-and-reconciliation',
  _reconciliation_relative_path: 'accounting-and-reconciliation',

  // Reconciliation menus
  reconciliation_pending: '/cash/accounting-and-reconciliation/pending',
  reconciliation_for_review: '/cash/accounting-and-reconciliation/for-review',
  reconciliation_recorded: '/cash/accounting-and-reconciliation/recorded',
  reconciliation_journal_entries:
    '/cash/accounting-and-reconciliation/journal-entries',
  reconciliation_reconciled: '/cash/accounting-and-reconciliation/reconciled',
  // Relative menu paths
  _pending_relative_path: 'pending',
  _for_review_relative_path: 'for-review',
  _recorded_relative_path: 'recorded',
  _journal_entries_relative_path: 'journal-entries',
  _reconciled_relative_path: 'reconciled',
  // For-review tabs
  reconciliation_for_review_reconcile:
    '/cash/accounting-and-reconciliation/for-review/reconcile',
  reconciliation_for_review_match:
    '/cash/accounting-and-reconciliation/for-review/match',
  reconciliation_for_review_categorize:
    '/cash/accounting-and-reconciliation/for-review/categorize',
  reconciliation_for_review_no_match:
    '/cash/accounting-and-reconciliation/for-review/no-match',

  // Relative tab paths
  _reconcile_relative_path: 'reconcile',
  _match_relative_path: 'match',
  _categorize_relative_path: 'categorize',
  _no_match_relative_path: 'no-match',

  // Reporting section
  reporting: '/cash/reporting',
  _reporting_relative_path: 'reporting',

  // Policies section
  policies: '/cash/policies',
  policies_precedents: '/cash/policies/precedents',
  _policies_relative_path: 'policies',
  _precedents_relative_path: 'precedents',

  // Helper to build policy detail URL
  policyDetail: (policyId: string) => `/cash/policies/${policyId}`,

  // Helper to build reconciliation menu URL
  reconciliationMenu: (menu: CashMenu) =>
    `/cash/accounting-and-reconciliation/${menu}`,

  // Helper to build for-review tab URL
  forReviewTab: (tab: CashTab) =>
    `/cash/accounting-and-reconciliation/for-review/${tab}`,
} as const;
